var _ = require('lodash');
var angular = require('angular/index');
require('../core');

angular.module('utility-ng-interface').factory('ArrayListBuilder', function ArrayListBuilderDefinition($injector) {
  return function ArrayListBuilder(list, builder) {
    builder = _.isString(builder) ? $injector.get(builder) : builder;

    return _.map(
      list,
      function (o) {
        return new this(o);
      },
      builder
    );
  };
});



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-interface/src/adt/array_list_builder.js